export default __webpack_public_path__ + "check-sign-in-a-rounded-black-square.png";